export default "__VITE_PUBLIC_ASSET__e5a7706c__"